/**
 * Created by Administrator on 2018/6/6.
 */
// import axios from 'axios'
import axios from '../../api/axios'
import router from '../../router'
import store from '../../store'
import { MessageBox } from 'mint-ui'
const state = {
  userMsg: {},
  partnerCompnay: ''
}
const mutations = {
  getUserMsg: function(state, userMsg) {
    state.userMsg = userMsg
  },
  setPartnerCompnay: function(state, partnerRealName) {
    var obj = {
      唐更祥: '邵阳祥乐网络营销推广有限公司',
      唐保林: '邵阳祥乐网络营销推广有限公司',
      唐皓: '邵阳祥乐网络营销推广有限公司',
      谢红春: '邵阳市鸿发网络营销有限公司',
      朱涵圭: '邵阳祥乐网络营销推广有限公司',
      刘勇翔: '邵阳祥乐网络营销推广有限公司',
      刘欢: '邵阳祥乐网络营销推广有限公司',
      李伟: '邵阳铭志网络营销推广有限公司',
      刘叶: '邵阳铭志网络营销推广有限公司',
      彭上城: '邵阳铭志网络营销推广有限公司',
      牛张杜: '邵阳铭志网络营销推广有限公司'
    }
    for (var key in obj) {
      if (partnerRealName == key) {
        state.partnerCompnay = obj[key]
      }
    }
  }
}
const actions = {
  getUserMsg({ commit }) {
    //{ commit }是参数解构的写法，ES6语法
    axios
      .get('/user/info', {})
      .then(function(res) {
        console.log(res)
        localStorage.setItem('code', res.code)
        localStorage.setItem('env', res.env.replace('-test', ''))
        if (res.code == 0) {
          commit('setPartnerCompnay', res.data.partnerRealName)
          commit('getUserMsg', res.data)
          localStorage.setItem('startTime', res.data.startTime)
          localStorage.setItem('endTime', res.data.endTime)
          localStorage.setItem(
            //用于活动页
            'diamondMall',
            JSON.stringify(res.data.fangkaStoreActivity)
          )
          if (!res.data.fangkaStoreActivity) {
            store.commit('deleteImg', { name: 'diamondMallActive' })
          }

          /**删除common过期图片，避免造成轮播图realIndex混乱**/
          for (var i = 0; i < store.state.envData.common.loop.length; i++) {
            if (
              state.userMsg.serverTime <
                store.state.envData.common.loop[i].startTime ||
              state.userMsg.serverTime >
                store.state.envData.common.loop[i].endTime
            ) {
              store.commit('deleteImgOutTime', state.userMsg.serverTime)
            }
          }
          /**删除对应地区过期图片，避免造成轮播图realIndex混乱**/
          for (
            var i = 0;
            i < store.state.envData[localStorage.env].loop.length;
            i++
          ) {
            if (
              state.userMsg.serverTime <
                store.state.envData[localStorage.env].loop[i].startTime ||
              state.userMsg.serverTime >
                store.state.envData[localStorage.env].loop[i].endTime
            ) {
              store.commit('deleteImgOutTime', state.userMsg.serverTime)
            }
          }
        } else {
          router.push('/login')
        }
      })
      .catch(function(error) {
        console.log(error)
      })
  }
}
export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/userMsg.js